export const PRESENCE_PEOPLE_MIN = 1;
export const PRESENCE_PEOPLE_MAX = 50;

/** Normalize an `HH:MM` (or `H:M`) time string to zero-padded `HH:MM`. */
export function padTimeString(value: string): string {
  if (!value) return "";
  const [hours, minutes] = value.split(":");
  return `${hours.padStart(2, "0")}:${(minutes || "00").padStart(2, "0")}`;
}

export function parseUtcDateTime(dateValue: string, timeValue: string): Date {
  const [year, month, day] = dateValue.split("-").map(Number);
  const [hours, minutes] = timeValue.split(":").map(Number);
  return new Date(Date.UTC(year, month - 1, day, hours || 0, minutes || 0));
}

export function clampPresencePeopleInput(raw: string): string {
  const parsed = parseInt(raw, 10);
  const value = Number.isNaN(parsed) ? PRESENCE_PEOPLE_MIN : parsed;
  return String(
    Math.min(PRESENCE_PEOPLE_MAX, Math.max(PRESENCE_PEOPLE_MIN, value)),
  );
}
